import useGetTableIndex from "../../../../../core/hooks/layout/useGetTableIndex"
import UserLink from "../../../../common/utils/UserLink"
import { CMargin, DText, Flex, Row } from "../../../../../styles/CommonStyles"
import Text from "../../../../../core/utils/Text"
import RTableLayout from "../../../../responsive/layout/RTableLayout"
import { formatName, getNames } from "../../../../../core/utils/common"
import { MiniLineBreak, RespIndex } from "../../../../../styles/main/MainCommonStyles"
import DateTime from "../../../../common/utils/DateTime"


const RAffiliatesTable = ({ data }) => {

    const { data: affiliates } = data

    const { getTableIndex } = useGetTableIndex()

    return (
        <RTableLayout data={data}>
            {affiliates?.data?.map((affiliate, idx) => {
                const { FULLNAME } = getNames(affiliate?.firstName, affiliate?.lastName)

                return (
                    <Row cs={'100%'} index={idx} key={affiliate._id}>
                        {/* User ID */}
                        <Flex justify='space-between'>
                            <DText main fontSize='s'>
                                <Text tid='user_id' /> :
                            </DText>
                            <UserLink
                                _id={affiliate._id}
                                name={affiliate._id}
                            />
                        </Flex>
                        <MiniLineBreak />

                        {/* Full Name */}
                        <Flex justify='space-between'>
                            <DText main fontSize='s'>
                                <Text tid='full_name' /> :
                            </DText>
                            <UserLink
                                _id={affiliate._id}
                                name={formatName(FULLNAME)}
                            />
                        </Flex>
                        <MiniLineBreak />

                        {/* Mobile */}
                        <Flex justify='space-between'>
                            <DText main fontSize='s'>
                                <Text tid='email' /> :
                            </DText>
                            <DText primary fontSize='s'>
                                {affiliate.email || '-'}
                            </DText>
                        </Flex>
                        <MiniLineBreak />

                        {/* Created At */}
                        <Flex justify='space-between'>
                            <DText main fontSize='s'>
                                <Text tid='created_at' /> :
                            </DText>
                            <DText primary fontSize='s'>
                                <DateTime dt={affiliate.createdAt} />
                            </DText>
                        </Flex>
                        <CMargin margin='6px' />

                        {/* Row Index */}
                        <RespIndex>
                            {getTableIndex(idx)}
                        </RespIndex>
                    </Row>
                )
            })}
        </RTableLayout>
    )
}

export default RAffiliatesTable
